import React, { useState } from 'react';
import moment from 'moment';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { Button } from 'reactstrap';
import { format } from '../../../functions/functions';
import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable.js";
import api from "../../../api/api.js";
import auth from "../../../auth/auth.js";
import apifunctions from "../../../api/functions";
import { useEffect } from 'react';
import { useContext } from 'react';

const FilterContext = React.createContext();

const columns = [
  {
    Header: "id",
    id: "id",
    accessor: "id",
    show: false,
    private: true,
  },
  {
    Header: "Fecha",
    id: "fecha",
    accessor: d => moment(d.fecha).format('DD/MM/YYYY'),
    className: "text-center",
    show: true,
    width: 100,
    filterable: false
  },
  {
    Header: "Tipo",
    id: "tipo",
    accessor: "tipo",
    width: 100,
    show: true,
    private: true,
    filterable: false
  },
  {
    Header: "Plan",
    id: "tipo_venta",
    accessor: (d) => (d.tipo_venta == "C" ? "CONTADO" : (d.tipo_venta == "F" ? "FINANCIADO" : "ESPECIAL")),
    className: "text-center",
    width: 150,
    filterable: true,
    show: true,
    Filter: ({ filter, onChange }) => (
      <FilterContext>
        {
          ({ updateFilters }) => {
            const _onChange = (event) => {
              const value = event.target.value;
              updateFilters({ filter_tipo_venta: value });
              onChange(value);
            }
            return (
              <select
                onChange={_onChange}
                style={{ width: "100%" }}
                value={filter ? filter.value : "TODOS"}
              >
                <option value="">TODOS</option>
                <option value={"C"}>CONTADO</option>
                <option value={"F"}>FINANCIADO</option>
                <option value={"E"}>ESPECIAL</option>
              </select>
            )
          }
        }
      </FilterContext>
    ),
  },
  {
    Header: "Loteo",
    id: "loteo_full_name",
    accessor: d => d.loteo_full_name,
    width: 300,
    show: false,
    filterable: false,
  },
  {
    Header: "Lote",
    id: "lote_full_name",
    width: 100,
    accessor: d => d.lote_full_name,
    show: true,
    filterable: true,
    Filter: ({ filter, onChange }) => (
      <FilterContext>
        {
          ({ updateFilters }) => {
            const _onChange = (event) => {
              const value = event.target.value;
              updateFilters({ filter_lote_full_name: value });
              onChange(value);
            }
            return (
              <input
                onChange={_onChange}
                style={{ width: "100%" }}
              />
            )
          }
        }
      </FilterContext>
    )
  },
  {
    Header: "Cuotas Pagas",
    id: "descripcion",
    Cell: d => d.original ? (d.original.descripcion && d.original.descripcion.toLowerCase() != "anticipo" ? d.original.descripcion : "") : "",
    show: true,
    filterable: false
  },
  {
    Header: "Anticipos",
    id: "id",
    Cell: d => d.original ? (d.original.descripcion && d.original.descripcion.toLowerCase() == "anticipo" ? d.original.descripcion : "") : "",
    show: true,
    filterable: false
  },
  {
    Header: "Ingreso",
    id: "monto_ingreso",
    width: 125,
    accessor: d => '$ ' + format(d.monto_ingreso),
    className: 'text-right',
    show: true,
    filterable: true,
    Filter: ({ }) => <div id="totalizador_monto_ingreso"></div>
  },
  {
    Header: "Egreso",
    id: "monto_egreso",
    width: 125,
    accessor: d => '$ ' + format(d.monto_egreso),
    className: 'text-right',
    show: true,
    filterable: true,
    Filter: ({ }) => <div id="totalizador_monto_egreso"></div>
  },
  {
    Header: "Subtotal",
    id: "id",
    Cell: d => "",
    width: 125,
    show: true,
    filterable: true,
    Filter: ({ }) => <div id="totalizador_monto_subtotal"></div>
  }
]

const ButtonExport = (props) => {

  const paramsExport = () => {

    let parameters = {};

    parameters.fields = columns.map(x => x.id)

    let filters = props.outerFilter.map(filter => {
      const data = filter.value;
      if (typeof data === "object") {
        return (data.lookup != null) ? `${filter.id}[${data.lookup}]=${data.input}` : `${filter.id}=${data.input}`;
      } else if (!data) {
        return;
      } else {
        const column = columns.find(col => col.id === filter.id);
        if (column && column.lookup) {
          return `${filter.id}[${column.lookup}]=${data}`;
        }
        return filter.id + "[icontains]=" + data;
      }
    }).filter(filter => !!filter);
    if (filters.length > 0) parameters.filters = filters;
    return parameters;
  }

  const exportMovimientos = () => {
    let header = auth.header();
    header.responseType = "blob";
    let params = paramsExport();

    let url = apifunctions.generateUrl(api.inversionista.movimientos.export, null, 1, params)

    axios.get(
      url, header
    ).then(
      response => {
        if (response.status == 200) {
          fileDownload(response.data, "Movimientos.xls")
        }
      })
  }

  return (
    <Button
      className={'icon btn-sm h-100 rounded tiny-btn'}
      color={'success'}
      onClick={exportMovimientos}
    >
      <i class="fa fa-download fa-lg" />
    </Button>
  );
}

const getOuterFilter = (filter) => {
  let toReturn = [];
  const { loteoId, desde, hasta } = filter;
  if (loteoId > 0)
    toReturn.push({
      id: 'loteo__id',
      value: {
        lookup: 'exact',
        input: loteoId
      }
    })

  if (desde && hasta) {
    toReturn.push({
      id: 'fecha',
      value: {
        lookup: 'range',
        input: `${moment(desde).format('YYYY-MM-DD')},${moment(hasta).format('YYYY-MM-DD')}`,
      }
    });
  }

  return toReturn
}

const TablaMovimientos = (props) => {
  useEffect(() => {
    if (props.filter) {
      let node_totalizador_monto_egreso = document.getElementById("totalizador_monto_egreso");
      let node_totalizador_monto_ingreso = document.getElementById("totalizador_monto_ingreso");
      let node_totalizador_monto_subtotal = document.getElementById("totalizador_monto_subtotal");

      const failureCallback = () => {
        if (node_totalizador_monto_egreso) node_totalizador_monto_egreso.innerText = "";
        if (node_totalizador_monto_ingreso) node_totalizador_monto_ingreso.innerText = "";
        if (node_totalizador_monto_subtotal) node_totalizador_monto_subtotal.innerText = "";
      }

      const successCallback = (response) => {
        if (response && response.data) {
          if (node_totalizador_monto_egreso) node_totalizador_monto_egreso.innerText = '$ ' + format(response.data.totalizador_monto_egreso);
          if (node_totalizador_monto_ingreso) node_totalizador_monto_ingreso.innerText = '$ ' + format(response.data.totalizador_monto_ingreso);
          if (node_totalizador_monto_subtotal) node_totalizador_monto_subtotal.innerText = '$ ' + format(response.data.totalizador_monto_subtotal);
        } else failureCallback();
      }

      const filters = []
      if (props.filter.desde && moment(props.filter.desde).isValid()) {
        filters.push(`desde=${moment(props.filter.desde).format('YYYY-MM-DD')}`);
      }
      if (props.filter.desde && moment(props.filter.desde).isValid()) {
        filters.push(`hasta=${moment(props.filter.hasta).format('YYYY-MM-DD')}`);
      }
      if (props.filter.loteoId) {
        filters.push(`loteo_id=${props.filter.loteoId}`);
      }

      if (props.filtersContext.filter_tipo_venta) {
        filters.push(`filter_tipo_venta=${props.filtersContext.filter_tipo_venta}`);
      }
      if (props.filtersContext.filter_lote_full_name) {
        filters.push(`filter_lote_full_name=${props.filtersContext.filter_lote_full_name}`);
      }
      apifunctions.get(api.inversionista.movimientos.totalizadores, null, null, { filters }, successCallback, failureCallback, failureCallback);
    }
  }, [props])

  return (
    <ParadigmaTable
      buttons={[
        {
          edit: true,
          component: (p) => <ButtonExport outerFilter={getOuterFilter(props.filter)} />,
          permission: 'inversionista_ingresos',
        },
      ]}
      depth={2}
      apiUrl={api.inversionista.movimientos.list}
      columns={columns}
      outerFilter={getOuterFilter(props.filter)}
      title={"Movimientos"}
      outerSort={[{
        id: 'fecha',
        desc: true,
      }, {
        id: 'lote_full_name',
        desc: true,
      }]}
    />
  )
}

const MaskedTablaMovimientos = (props) => {
  const [filters, setFilters] = useState({
    filter_tipo_venta: "",
    filter_lote_full_name: "",
  });
  const updateFilters = (newState) => {
    setFilters({ ...filters, ...newState });
  }

  return (
    <FilterContext.Provider value={{ filters, updateFilters }}>
      <TablaMovimientos {...props} filtersContext={filters} />
    </FilterContext.Provider>
  )
}

export default MaskedTablaMovimientos;


// WEBPACK FOOTER //
// ./src/views/Inversionistas/Resumen/TablaMovimientos.js